import { CerFormAdapter } from "@form/cer-form-adapter";
import { CerFormViewSet } from "@form/cer-form-view-set";
import { CerFormView } from "@form/cer-form-view";
import { CerFormPanesSettingsUtil } from "@form/cer-form-panes/cer-form-panes.service";

export class DataTableForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    //viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 30);
    //viewSet.viewAdd(DataTableForm.fieldsViewGet(), 
      viewSet.viewAdd(DataTableForm.tableViewGet())
    //);
  }

  private static tableViewGet(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'tabeller', dataApiName: 'DataTable', text: 'App Tabeller', textSingular: 'App Tabel',
        primaryKey: 'id', baseFields: ['id', 'name', 'history']
      },
      fieldMetadata: [
        { name: 'isDynamic', text: 'Tilpasning', allowEdit: false, allowEditOnAdd: false, format: 'CheckBox', defaultValue: true },
        { name: 'documentLib', text: 'Arkiv', tooltipText: 'Dokumentarkiv', foreignKeyTableName: 'DocumentLib' },
        { name: 'documentLibPath', text: 'Arkiv sti', tooltipText: 'Dokumentarkiv sti skabelone' }
      ]
    });
  }

  private static fieldsViewGet(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'tabel-felter', dataApiName: 'DataTableColumns', text: 'Felter', textSingular: 'Felt',
        primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'dataProcessStage', baseFields: ['id', 'name', 'history']
      },
      fieldMetadata:
        [
          { name: 'isDynamic', text: 'Tilpasning', required: true, allowEdit: false, allowEditOnAdd: false, format: 'CheckBox', defaultValue: true },
          { name: 'order', text: 'Rækkefølge', required: true, format: 'Integer', orderBy: 'Ascending', orderByPriority: 1 },
          { name: 'title', text: 'Titel', required: true }
        ]
    });
  }
}

